import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "scroll",
  class: "h-full overflow-y-auto space-y-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_rating = _resolveComponent("card-rating")!
  const _component_card_comment = _resolveComponent("card-comment")!
  const _component_card_lecture = _resolveComponent("card-lecture")!
  const _component_card_user = _resolveComponent("card-user")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [
        (item.type === 'rating')
          ? (_openBlock(), _createBlock(_component_card_rating, {
              key: 0,
              rating: item
            }, null, 8, ["rating"]))
          : (item.type === 'comment')
            ? (_openBlock(), _createBlock(_component_card_comment, {
                key: 1,
                comment: item
              }, null, 8, ["comment"]))
            : (item.type === 'lecture')
              ? (_openBlock(), _createBlock(_component_card_lecture, {
                  key: 2,
                  lecture: item
                }, null, 8, ["lecture"]))
              : (item.type === 'user')
                ? (_openBlock(), _createBlock(_component_card_user, {
                    key: 3,
                    user: item
                  }, null, 8, ["user"]))
                : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 512))
}